module.exports = __webpack_public_path__ + "img/area-limit-bg.91f24cf4.png";